module.exports = __webpack_public_path__ + "static/media/till-slip.38ac9f87.png";